export default __webpack_public_path__ + "static/media/birds-top.2336e860.svg";